import React, { useState } from 'react';
import { Button as ANTButton, Form } from 'antd';
import Input from 'components/Atom/Input';
import { Button } from 'components/Atom/Button';
import { useSelector } from 'react-redux';
import { notification } from 'antd';
import { addDeclineListEntry } from 'api/xShields';

const AddEntry = ({ handleOpen, refetch, tabTypes, activeTab, tabMappings }) => {
  const store = useSelector((state) => state.company.store);
  const userStores = useSelector((state) => state?.company?.userStores);
  const [isValueAdding, setIsValueAdding] = useState(false);
  const onAddSubmit = async (values) => {
    if (userStores?.length > 1 && !store?.isSelected) {
      notification.error({ message: 'Select store from the drop-down menu above', placement: 'bottomRight' });
      return;
    }
    setIsValueAdding(true);
    const { value } = values;
    const payload = {
      [tabTypes[activeTab]]: value,
    };
    const response = await addDeclineListEntry(store?._id, payload, tabMappings[activeTab]);
    if (response?.data?.success) {
      handleOpen();
      refetch();
    }
    setIsValueAdding(false);
  };

  const getValidationRules = () => {
    switch (tabMappings[activeTab]) {
      case 'BIN':
        return [
          { required: true, message: 'BIN is required' },
          { pattern: /^(\d{6}|\d{8})$/, message: 'BIN must be exactly 6 or 8 digits' },
        ];
      case 'Email Address':
        return [
          { required: true, message: 'Email Address is required' },
          { type: 'email', message: 'Enter a valid email address' },
        ];
      case 'Phone':
        return [
          { required: true, message: 'Phone number is required' },
          { pattern: /^\+?[0-9]{10,15}$/, message: 'Enter a valid phone number (10-15 digits, optional + at the start)' },
        ];
      case 'IP Address':
        return [
          { required: true, message: 'IP Address is required' },
          { pattern: /^(?:\d{1,3}\.){3}\d{1,3}$/, message: 'Enter a valid IP address' },
        ];
      case 'Card Fingerprint':
        return [
          { required: true, message: 'Card Fingerprint is required' },
          { pattern: /^[^%?{}[\]$^*@<>]*$/, message: 'Enter a valid Card Fingerprint' },
        ];
      default:
        return [{ required: true, message: 'This field is required' }];
    }
  };

  const getInputType = () => {
    switch (tabMappings[activeTab]) {
      case 'BIN':
      case 'Phone':
        return 'text';
      case 'Email Address':
        return 'email';
      case 'IP Address':
      case 'Card Fingerprint':
        return 'text';
      default:
        return 'text';
    }
  };

  return (
    <div className='formDetails'>
      <Form layout='vertical' onFinish={onAddSubmit}>
        <div className=''>
          <Form.Item name='value' label={tabMappings[activeTab]} className={`customInput mobileInputView steric-after`} rules={getValidationRules()}>
            <Input type={getInputType()} placeholder={`Type the ${tabMappings[activeTab]} you want to add`} name='value' />
          </Form.Item>
        </div>
        <div className='mb-[-20px] form_button update-button'>
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <ANTButton block className='rounded-lg' onClick={() => handleOpen()}>
                Cancel
              </ANTButton>
              <Button block className='button-theme ml-4 rounded-lg' htmlType='submit' loading={isValueAdding}>
                Add
              </Button>
            </div>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};
export default AddEntry;
